<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="bookingPriceForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="officeId">Office</label>
              <select id="officeId" class="form-control" formControlName="officeId">
                <option *ngFor="let office of offices" [value]="office.id">{{ office.city + ' ' + office.address }}</option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="roomId">Room</label>
              <select id="roomId" class="form-control" formControlName="roomId">
                <option *ngFor="let room of rooms" [value]="room.id">{{ room.name }}</option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="bookingOption">Option</label>
              <select id="bookingOption" class="form-control" formControlName="bookingOption">
                <option *ngFor="let bookingOption of bookingOptions" [value]="bookingOption">{{ bookingOption }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="timePeriodId">Time Period</label>
              <select id="timePeriodId" class="form-control" formControlName="timePeriodId">
                <option *ngFor="let timePeriod of timePeriods" [value]="timePeriod.id">{{ timePeriod.name }}</option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="price">Price</label>
              <input type="text" class="form-control" formControlName="price" id="price" placeholder="Price">
            </div>
            <div class="col-md-4 mb-3">
              <label for="currency">Currency</label>
              <select id="currency" class="form-control" formControlName="currency">
                <option *ngFor="let currency of currencies" [value]="currency">{{ currency }}</option>
              </select>
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(bookingPriceForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
